import { render, staticRenderFns } from "./Proxy.vue?vue&type=template&id=2fe453ec&scoped=true"
import script from "./Proxy.vue?vue&type=script&lang=js"
export * from "./Proxy.vue?vue&type=script&lang=js"
import style0 from "./Proxy.vue?vue&type=style&index=0&id=2fe453ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe453ec",
  null
  
)

export default component.exports